module.exports = __webpack_public_path__ + "media/images/front/menu_db03-132d218d2ecfb62e7f282fb6dd4ccbab.jpg";